import { PairedCostAdjustments } from '@aloft/toolkit-shared';

import { Tkv2OrderContext } from '../../../../controller/types.js';
import { FeaturesAndAdjustments } from '../types.js';
import { getAdjustment } from './getAdjustment.js';
import { getAdjustmentTooltip } from './getAdjustmentTooltip.js';
import { getFeatureValue } from './getFeatureValue.js';

export const makeExceptionsDictionary = (
  context: Tkv2OrderContext,
  compID: string,
): Pick<FeaturesAndAdjustments, 'site' | 'mainDwelling' | 'locationView'> => ({
  site:
    context.pairedCostVersion === 'simplified_v1'
      ? {
          value: getFeatureValue(context, compID, 'site')?.text,
          adjustment: getAdjustment(context, compID, 'site'),
          tooltip: getAdjustmentTooltip(context, compID, 'site'),
          summary: context.pairedCostResults.adjustmentSummaries?.site,
        }
      : {
          size: {
            value: getFeatureValue(context, compID, 'site')?.size,
            adjustment: getAdjustment(context, compID, 'site'),
            tooltip: getAdjustmentTooltip(context, compID, 'site'),
          },
          location: {
            value: getFeatureValue(context, compID, 'site')?.location as string | undefined,
            adjustment: getAdjustment(context, compID, 'locationView'),
            tooltip: getAdjustmentTooltip(context, compID, 'locationView'),
          },
          view: {
            value: getFeatureValue(context, compID, 'site')?.view,
          },
        },
  mainDwelling: {
    gla: {
      value: getFeatureValue(context, compID, 'mainDwelling')?.text,
      adjustment: getAdjustment(context, compID, 'mainDwelling' as keyof PairedCostAdjustments),
      tooltip: getAdjustmentTooltip(context, compID, 'mainDwelling' as keyof PairedCostAdjustments),
      summary: context.pairedCostResults.adjustmentSummaries?.mainDwelling,
    },
    propertyType: {
      value: getFeatureValue(context, compID, 'mainDwelling')?.propertyType,
    },
    sections: {
      value: getFeatureValue(context, compID, 'mainDwelling')?.sections,
    },
    units: {
      value: getFeatureValue(context, compID, 'mainDwelling')?.units,
    },
  },
  locationView: {
    location: {
      value: getFeatureValue(context, compID, 'site')?.location,
      adjustment: getAdjustment(context, compID, 'locationView'),
      tooltip: getAdjustmentTooltip(context, compID, 'locationView'),
    },
    view: {
      value: getFeatureValue(context, compID, 'site')?.view,
    },
  },
});
